import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { ApplicationState, AppState } from '../../../store';
import { withSnackbar, ProviderContext } from 'notistack';
import { ITranslatorService } from '../../../services/Interfaces/ITranslatorService';
import { ApplicationContext, AppContext } from '../../../context/Contexts';
import { IOrganizationService } from '../../../services/Interfaces/IOrganizationService';
import {
  Box,
  Switch,
  Button,
  IconButton,
  Card,
  CardContent,
  DialogTitle,
  Dialog,
  Grid,
  Typography,
  DialogContent
} from '@material-ui/core';
import { ScaleLoader } from 'react-spinners';
import MUIDataTable, {
  MUIDataTableColumnOptions,
  MUIDataTableMeta,
  SelectableRows
} from 'mui-datatables';
import moment from 'moment';
import { MUITranslations } from '../../../helpers/MUITableTranslations';
import { RouteComponentProps } from 'react-router';
import { ValidatorForm, TextValidator } from 'react-material-ui-form-validator';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { IReferentialService } from '../../../services/Interfaces/IReferentialService';
import DeleteOutlineTwoToneIcon from '@material-ui/icons/DeleteOutlineTwoTone';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import CloseIcon from '@material-ui/icons/Close';
import EditWorkflowForm from '../workflows/editWorkflowForm/EditWorkflowForm';
import {
  WorkflowSection,
  WorkflowSectionStep,
  WorkflowSectionStepForm,
  WorkflowForm
} from '../../../interfaces/Workflow';
import { IWorkflowService } from '../../../services/Interfaces/IWorkflowService';

interface IWorkflowCaseStructureFormState {
  workflowSectionStepForms: WorkflowSectionStepForm[];
  isLoading: boolean;
  workflowSectionTypes: WorkflowSection[];
  workflowSectionStepTypes: WorkflowSectionStep[];
  workflowSectionStepFormTypes: WorkflowForm[];
  selectedWorkflowSectionType: WorkflowSection | null;
  selectedWorkflowSectionStepType: WorkflowSectionStep | null;
  selectedWorkflowSectionStepFormType: WorkflowForm | null;
  workflowId: number;
  formId: number;
  formCode: string | null;
  isOpenDialog: boolean;
  isDialogDeleteOpen: boolean;
  deleteFormId: number | null;
  modalFormTitle: string;
}

type IWorkflowCaseStructureFormProps = { appState: AppState } & ProviderContext &
  RouteComponentProps<{ id: string; workflowId: string }>;

class WorkflowCaseStructureFormsTab extends React.PureComponent<
  IWorkflowCaseStructureFormProps,
  IWorkflowCaseStructureFormState
> {
  private translatorService!: ITranslatorService;
  private organizationService!: IOrganizationService;
  private workflowService!: IWorkflowService;
  private appReferentialService!: IReferentialService;

  static contextType = ApplicationContext;

  state = {
    workflowSectionStepForms: [],
    workflowSectionTypes: [],
    isLoading: false,
    workflowSectionStepTypes: [],
    workflowSectionStepFormTypes: [],

    selectedWorkflowSectionStepType: null,
    selectedWorkflowSectionStepFormType: null,
    selectedWorkflowSectionType: null,
    workflowId: 0,
    formId: 0,
    formCode: null,
    isOpenDialog: false,
    isDialogDeleteOpen: false,
    deleteFormId: null,
    modalFormTitle: 'Configurare forma'
  } as IWorkflowCaseStructureFormState;

  public componentDidMount() {
    const hoId = Number.parseInt(this.props.match.params.id);
    const workflowId = Number.parseInt(this.props.match.params.workflowId);

    if (Number.isNaN(hoId) || Number.isNaN(workflowId)) {
      return;
    }

    this.setState(
      {
        isLoading: true
      },
      async () => {
        await this.loadWorkflowForms();
      }
    );
  }

  loadWorkflowForms = async () => {
    const hoId = Number.parseInt(this.props.match.params.id);
    const workflowId = Number.parseInt(this.props.match.params.workflowId);

    if (Number.isNaN(hoId) || Number.isNaN(workflowId)) {
      return;
    }

    const [workflowSectionList, filterSectionStepForms] = await Promise.all([
      this.workflowService.GetWorkflowSections(workflowId),
      this.workflowService.GetWorkflowForms()
    ]);

    this.setState({
      workflowSectionTypes: workflowSectionList.sort(function (a, b) {
        return a.order - b.order;
      }),
      workflowSectionStepFormTypes: filterSectionStepForms,
      isLoading: false,
      workflowId: workflowId
    });
  };

  reloadWorkflowForms = async (sectionStepId: number | null) => {
    if (sectionStepId === null) {
      this.setState({
        workflowSectionStepForms: [],
        isLoading: false
      });
      return;
    }

    const workflowSectionStepFormList = await this.workflowService.GetWorkflowSectionStepForms(
      sectionStepId
    ); //orgCaseList[0].id);

    this.setState({
      workflowSectionStepForms: workflowSectionStepFormList.sort(function (a, b) {
        return a.order - b.order;
      }),
      isLoading: false
    });
  };

  moveUp = async (event: any, tableMeta: MUIDataTableMeta) => {
    const id = tableMeta.rowData[0];
    const cloneArray = [...this.state.workflowSectionStepForms];
    const itemToMoveUpIndex = cloneArray.findIndex((item) => item.id === id);

    if (itemToMoveUpIndex === -1) {
      return;
    }
    if (cloneArray[itemToMoveUpIndex].order === 1) {
      return;
    }

    const itemToMoveDownIndex = cloneArray.findIndex(
      (item) => item.order === cloneArray[itemToMoveUpIndex].order - 1
    );

    cloneArray[itemToMoveUpIndex] = {
      ...cloneArray[itemToMoveUpIndex],
      order: cloneArray[itemToMoveUpIndex].order - 1
    };
    cloneArray[itemToMoveDownIndex] = {
      ...cloneArray[itemToMoveDownIndex],
      order: cloneArray[itemToMoveDownIndex].order + 1
    };

    try {
      await this.workflowService.UpdateWorkflowSectionStepForm(cloneArray[itemToMoveUpIndex]);
      await this.workflowService.UpdateWorkflowSectionStepForm(cloneArray[itemToMoveDownIndex]);

      this.setState({
        workflowSectionStepForms: cloneArray.sort(function (a, b) {
          return a.order - b.order;
        })
      });
      this.props.enqueueSnackbar(this.translatorService.Tranlate('SUCCES_MSG', 'OK'), {
        variant: 'success'
      });
    } catch (error) {
      this.props.enqueueSnackbar(this.translatorService.Tranlate('ERROR_MSG', 'Eroare'), {
        variant: 'error'
      });
    }
  };

  moveDown = async (event: any, tableMeta: MUIDataTableMeta) => {
    const id = tableMeta.rowData[0];
    const cloneArray = [...this.state.workflowSectionStepForms];
    const itemToMoveIndex = cloneArray.findIndex((item) => item.id === id);

    if (itemToMoveIndex === -1) {
      return;
    }
    if (cloneArray[itemToMoveIndex].order === cloneArray.length) {
      return;
    }

    const itemToMoveToIndex = cloneArray.findIndex(
      (item) => item.order === cloneArray[itemToMoveIndex].order + 1
    );

    cloneArray[itemToMoveIndex] = {
      ...cloneArray[itemToMoveIndex],
      order: cloneArray[itemToMoveIndex].order + 1
    };
    cloneArray[itemToMoveToIndex] = {
      ...cloneArray[itemToMoveToIndex],
      order: cloneArray[itemToMoveToIndex].order - 1
    };

    try {
      await this.workflowService.UpdateWorkflowSectionStepForm(cloneArray[itemToMoveIndex]);
      await this.workflowService.UpdateWorkflowSectionStepForm(cloneArray[itemToMoveToIndex]);

      this.setState({
        workflowSectionStepForms: cloneArray.sort(function (a, b) {
          return a.order - b.order;
        })
      });
      this.props.enqueueSnackbar(this.translatorService.Tranlate('SUCCES_MSG', 'OK'), {
        variant: 'success'
      });
    } catch (error) {
      this.props.enqueueSnackbar(this.translatorService.Tranlate('ERROR_MSG', 'Eroare'), {
        variant: 'error'
      });
    }
  };

  onRowClick = (e: any, id: number, formCode: string | null, formName: any) => {
    this.setState({ isOpenDialog: true, formId: id, modalFormTitle: formName, formCode });
  };

  handleClose = (showForm: boolean) => {
    this.setState({ isOpenDialog: showForm }, async () => {
      await this.reloadWorkflowForms(this.state.selectedWorkflowSectionStepType!.id);
    });
  };

  handleIsActiveChange = async (
    event: React.ChangeEvent<HTMLInputElement>,
    tableMeta: MUIDataTableMeta
  ) => {
    const id = tableMeta.rowData[0];
    const workflowSectionStepForms = [...this.state.workflowSectionStepForms];
    const updatedWorkflowSectionStepFormIndex = workflowSectionStepForms.findIndex(
      (o) => o.id === id
    );

    if (updatedWorkflowSectionStepFormIndex >= 0) {
      workflowSectionStepForms[updatedWorkflowSectionStepFormIndex] = {
        ...workflowSectionStepForms[updatedWorkflowSectionStepFormIndex],
        isActive: event.target.checked
      };

      try {
        await this.workflowService.UpdateWorkflowSectionStepForm(
          workflowSectionStepForms[updatedWorkflowSectionStepFormIndex]
        );

        this.setState({ workflowSectionStepForms: workflowSectionStepForms });

        this.props.enqueueSnackbar(this.translatorService.Tranlate('SUCCES_MSG', 'OK'), {
          variant: 'success'
        });
      } catch (error) {
        this.props.enqueueSnackbar(this.translatorService.Tranlate('ERROR_MSG', 'Eroare'), {
          variant: 'error'
        });
      }
    }
  };

  getColumns = () => {
    const columns = [
      {
        name: 'id',
        options: { display: 'excluded', filter: false } as MUIDataTableColumnOptions
      },
      {
        name: 'displayName',
        label: this.translatorService.Tranlate(
          'WORKFLOWS_TAB_CASE_STRUCTURE_TAB_FORM_FORM_HEADER',
          'Forma'
        ),
        options: {
          sort: false,
          customBodyRender: (value: any, tableMeta: MUIDataTableMeta) => {
            const formId = tableMeta.rowData[0];
            const formCode =
              this.state.workflowSectionStepForms?.find(
                (wfSectionForm) => wfSectionForm.id === formId
              )?.form?.code || null;
            return (
              <Button
                color="primary"
                className=" text-primary"
                onClick={(e) => this.onRowClick(e, formId, formCode, value)}
              >
                <span>{value}</span>
              </Button>
            );
          }
        } as MUIDataTableColumnOptions
      },
      {
        name: 'dateModification',
        label: this.translatorService.Tranlate(
          'WORKFLOWS_TAB_CASE_STRUCTURE_TAB_FORM_DATE_MODIFICATION_HEADER',
          'Data Modificare'
        ),
        options: {
          sort: false,
          customBodyRender: (value: Date) =>
            moment.utc(value).local().format(this.props.appState.longDateFormat)
        } as MUIDataTableColumnOptions
      },
      {
        name: 'order',
        sortDirection: 'asc',
        label: this.translatorService.Tranlate(
          'WORKFLOWS_TAB_CASE_STRUCTURE_TAB_FORM_ORDER_HEADER',
          'Ord'
        ),
        options: { sort: false }
      },
      {
        name: '',
        options: {
          setCellHeaderProps: () => ({ align: 'center' }),
          setCellProps: () => ({ align: 'center' }),
          sortOrder: {
            name: 'order',
            direction: 'asc'
          },
          customBodyRender: (value: boolean, tableMeta: MUIDataTableMeta) => {
            return (
              <Fragment>
                <IconButton color="inherit" size="small" onClick={(e) => this.moveUp(e, tableMeta)}>
                  <KeyboardArrowUpIcon />
                </IconButton>
                <IconButton
                  color="inherit"
                  size="small"
                  onClick={(e) => this.moveDown(e, tableMeta)}
                >
                  <KeyboardArrowDownIcon />
                </IconButton>
              </Fragment>
            );
          }
        }
      },
      {
        name: 'isActive',
        label: this.translatorService.Tranlate('USERS_IS_ACTIVE_HEADER', 'Activ'),
        options: {
          sort: false,
          filterOptions: {
            names: [
              this.translatorService.Tranlate('TABLE_IS_ACTIVE_COLUMN_ACTIVE', 'Activ'),
              this.translatorService.Tranlate('TABLE_IS_ACTIVE_COLUMN_INACTIVE', 'Inactiv')
            ],
            logic(isActive: any, filterVal: string[]) {
              const show =
                (filterVal.indexOf(this.names[0]) !== -1 && isActive === true) ||
                (filterVal.indexOf(this.names[1]) !== -1 && isActive === false);
              return !show;
            }
          },
          customBodyRender: (value: boolean, tableMeta: MUIDataTableMeta) => {
            return (
              <Switch
                checked={value ? value : false}
                onChange={(e) => this.handleIsActiveChange(e, tableMeta)}
                color="primary"
                inputProps={{ 'aria-label': 'primary checkbox' }}
              />
            );
          }
        }
      },
      {
        name: '',
        options: {
          setCellHeaderProps: () => ({ align: 'center' }),
          setCellProps: () => ({ align: 'center' }),
          customBodyRender: (value: boolean, tableMeta: MUIDataTableMeta) => {
            return (
              <IconButton
                aria-label="delete"
                color="inherit"
                className="text-danger"
                size="small"
                onClick={(e) =>
                  this.setState({ isDialogDeleteOpen: true, deleteFormId: tableMeta.rowData[0] })
                }
              >
                <DeleteOutlineTwoToneIcon />
              </IconButton>
            );
          }
        }
      }
    ];

    return columns;
  };

  addOrgForm = async () => {
    try {
      const translations = this.state.selectedWorkflowSectionStepFormType!.translations;
      translations.forEach((item) => {
        item.id = 0;
        item.referentialTypeId = 0;
      });

      await this.workflowService.AddWorkflowSectionStepForm({
        order: this.state.workflowSectionStepForms.length + 1,
        json1: this.state.selectedWorkflowSectionStepFormType!.json1,
        json2: this.state.selectedWorkflowSectionStepFormType!.json2,
        translations: translations,
        formTypeId: this.state.selectedWorkflowSectionStepFormType!.formTypeId,
        workflowSectionStepId: this.state.selectedWorkflowSectionStepType!.id,
        formId: this.state.selectedWorkflowSectionStepFormType!.id,
        isActive: true
      } as WorkflowSectionStepForm);

      this.setState(
        {
          isLoading: true,
          selectedWorkflowSectionStepFormType: null
        },
        () => {
          this.reloadWorkflowForms(this.state.selectedWorkflowSectionStepType!.id);
        }
      );

      this.props.enqueueSnackbar(this.translatorService.Tranlate('SUCCES_MSG', 'OK'), {
        variant: 'success'
      });
    } catch (error) {
      this.props.enqueueSnackbar(this.translatorService.Tranlate('ERROR_MSG', 'Eroare'), {
        variant: 'error'
      });
    }
  };

  handleAutocompleteStepChange = (newValue: any | null) => {
    this.setState(
      {
        selectedWorkflowSectionStepType: newValue,
        isLoading: true
      },
      () => {
        this.reloadWorkflowForms(newValue === null ? null : newValue.id);
      }
    );
  };

  handleAutocompleteFormChange = (newValue: any | null) => {
    this.setState({ selectedWorkflowSectionStepFormType: newValue });
  };

  handleAutocompleteCaseChange = async (newValue: any | null) => {
    if (newValue === null) {
      this.setState(
        {
          selectedWorkflowSectionType: null,
          workflowSectionStepTypes: [],
          selectedWorkflowSectionStepType: null,
          isLoading: true
        },
        () => {
          this.reloadWorkflowForms(newValue === null ? null : newValue.id);
        }
      );
      return;
    }
    const workflowSectionStepList = await this.workflowService.GetWorkflowSectionSteps(newValue.id);

    this.setState(
      {
        selectedWorkflowSectionType: newValue,
        workflowSectionStepTypes: workflowSectionStepList.sort(function (a, b) {
          return a.order - b.order;
        }),
        selectedWorkflowSectionStepType: null,
        isLoading: true
      },
      () => {
        this.reloadWorkflowForms(null);
      }
    );
  };

  public renderAddForm() {
    return (
      <Box mt={1} pt={1}>
        <Card elevation={1}>
          <CardContent>
            <ValidatorForm onSubmit={this.addOrgForm}>
              <Autocomplete
                id="sectionType"
                className="m-2"
                fullWidth
                options={this.state.workflowSectionTypes}
                value={this.state.selectedWorkflowSectionType}
                onChange={(e: any, newValue: WorkflowSection | null) =>
                  this.handleAutocompleteCaseChange(newValue)
                }
                getOptionLabel={(option: WorkflowSection) => option.section!.displayName}
                renderInput={(params) => (
                  <TextValidator
                    {...params}
                    name="sectionType"
                    value={this.state.selectedWorkflowSectionType}
                    label={this.translatorService.Tranlate(
                      'WORKFLOWS_TAB_CASE_STRUCTURE_TAB_FORM_SECTION_LEBEL',
                      'Sectiune dosar'
                    )}
                    fullWidth
                    validators={['required']}
                    errorMessages={[
                      this.translatorService.Tranlate(
                        'VALIDATORS_REQUIRED',
                        'Campul este obligatoriu'
                      )
                    ]}
                  />
                )}
              />

              <Autocomplete
                id="stepType"
                className="m-2"
                fullWidth
                options={this.state.workflowSectionStepTypes}
                value={this.state.selectedWorkflowSectionStepType}
                onChange={(e: any, newValue: WorkflowSectionStep | null) =>
                  this.handleAutocompleteStepChange(newValue)
                }
                getOptionLabel={(option: WorkflowSectionStep) =>
                  option.workflowStep!.displayName || ''
                }
                renderInput={(params) => (
                  <TextValidator
                    {...params}
                    name="stepType"
                    value={this.state.selectedWorkflowSectionStepType}
                    label={this.translatorService.Tranlate(
                      'WORKFLOWS_TAB_CASE_STRUCTURE_TAB_FORM_STEP_LABEL',
                      'Pas'
                    )}
                    fullWidth
                    validators={['required']}
                    errorMessages={[
                      this.translatorService.Tranlate(
                        'VALIDATORS_REQUIRED',
                        'Campul este obligatoriu'
                      )
                    ]}
                  />
                )}
              />

              <Autocomplete
                id="formTypes"
                className="m-2"
                fullWidth
                options={this.state.workflowSectionStepFormTypes}
                value={this.state.selectedWorkflowSectionStepFormType}
                onChange={(e: any, newValue: WorkflowForm | null) =>
                  this.handleAutocompleteFormChange(newValue)
                }
                getOptionLabel={(option: WorkflowForm) => option.displayName}
                renderInput={(params) => (
                  <TextValidator
                    {...params}
                    name="formTypes"
                    value={this.state.selectedWorkflowSectionStepFormType}
                    label={this.translatorService.Tranlate(
                      'WORKFLOWS_TAB_CASE_STRUCTURE_TAB_FORM_FORM_TYPE_LABEL',
                      'Forma'
                    )}
                    fullWidth
                    validators={['required']}
                    errorMessages={[
                      this.translatorService.Tranlate(
                        'VALIDATORS_REQUIRED',
                        'Campul este obligatoriu'
                      )
                    ]}
                  />
                )}
              />

              <div className="text-right">
                <Button className="m-2" variant="contained" color="secondary" type="submit">
                  {this.translatorService.Tranlate('ADMIN_EDIT_USER_ROLES_BTN_ADD', 'ADAUGA')}
                </Button>
              </div>
            </ValidatorForm>
          </CardContent>
        </Card>
      </Box>
    );
  }

  closeDeleteDialog = async () => {
    this.setState({ isDialogDeleteOpen: false });
  };

  deleteWorkflowSectionStepForm = async () => {
    try {
      await this.workflowService.RemoveWorkflowForm(this.state.deleteFormId!);
      await this.reloadWorkflowForms(this.state.selectedWorkflowSectionStepType!.id);

      this.props.enqueueSnackbar(this.translatorService.Tranlate('SUCCES_MSG', 'OK'), {
        variant: 'success'
      });
    } catch (error) {
      this.props.enqueueSnackbar(this.translatorService.Tranlate('ERROR_MSG', 'Eroare'), {
        variant: 'error'
      });
    }
  };

  public render() {
    this.translatorService = (this.context as AppContext).translatorService;
    this.organizationService = (this.context as AppContext).organizationService;
    this.workflowService = (this.context as AppContext).workflowService;
    this.appReferentialService = (this.context as AppContext).referentialService;

    const options = {
      filter: false,
      search: false,
      viewColumns: false,
      selectableRows: 'none' as SelectableRows,
      selectableRowsOnClick: false,
      print: false,
      download: false,
      textLabels: MUITranslations.GetTranslations(this.translatorService),
      elevation: 1
    };

    return (
      <Fragment>
        {this.renderAddForm()}
        <Box mt={1} pt={1}>
          <div className="d-flex flex-row text-center flex-wrap justify-content-center">
            <ScaleLoader color={'var(--primary)'} loading={this.state.isLoading} />
          </div>
          {!this.state.isLoading ? (
            <MUIDataTable
              title={''}
              data={this.state.workflowSectionStepForms}
              columns={this.getColumns()}
              options={options}
            />
          ) : null}
        </Box>
        <Dialog
          aria-labelledby="customized-dialog-title"
          open={this.state.isOpenDialog}
          fullWidth={true}
          maxWidth="md"
          scroll="body"
        >
          <DialogTitle>
            <Grid container>
              <Grid item xs={11}>
                <Typography variant="h4">{this.state.modalFormTitle}</Typography>
              </Grid>
              <Grid item xs={1} className="text-right">
                <IconButton
                  aria-label="close"
                  onClick={() => this.handleClose(false)}
                  size={'small'}
                >
                  <CloseIcon />
                </IconButton>
              </Grid>
            </Grid>
          </DialogTitle>

          <DialogContent dividers style={{ backgroundColor: '#fafafa' }}>
            <EditWorkflowForm
              {...this.props}
              workflowFormId={this.state.formId}
              workflowFormChanged={this.handleClose}
              workflowFormCode={this.state.formCode}
            />
          </DialogContent>
        </Dialog>

        <Dialog
          onClose={this.closeDeleteDialog}
          aria-labelledby="customized-dialog-title"
          open={this.state.isDialogDeleteOpen}
          fullWidth={true}
          maxWidth={'sm'}
        >
          <div className="text-center p-5">
            <h4 className="font-weight-bold mt-4">
              {this.translatorService.Tranlate(
                'DELETE_TEXT',
                'Sigur doriti sa stergeti aceasta inregistrare?'
              )}
            </h4>
            <div className="pt-4">
              <Button
                onClick={this.closeDeleteDialog}
                variant="outlined"
                color="primary"
                className="mx-1"
              >
                <span className="btn-wrapper--label">
                  {this.translatorService.Tranlate('CANCEL', 'Anuleaza')}
                </span>
              </Button>
              <Button
                onClick={() => {
                  this.setState(
                    { isDialogDeleteOpen: false },
                    async () => await this.deleteWorkflowSectionStepForm()
                  );
                }}
                color="secondary"
                variant="contained"
                className="mx-1"
              >
                <span className="btn-wrapper--label">
                  {this.translatorService.Tranlate('DELETE', 'Sterge')}
                </span>
              </Button>
            </div>
          </div>
        </Dialog>
      </Fragment>
    );
  }
}

export default connect(
  (state: ApplicationState) => ({
    appState: state.app
  }),
  null
)(withSnackbar(WorkflowCaseStructureFormsTab as any));
